import { useMemo, useState } from 'react'

import { getClassByFlexDirectionBreak } from 'core-components/sitebuilder/layout/flexItem/helpers/getClassByFlexDirectionBreak'
import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'

interface IUseColumnSizeData {
  itemSize: FlexDirectionBreak
}

export const useColumnSizeData = ({ itemSize }: IUseColumnSizeData) => {
  const [stateColSize, setColSize] = useState<FlexDirectionBreak | undefined>()
  const columnSize = useMemo(() => stateColSize || itemSize, [stateColSize, itemSize])
  const columnClasses = useMemo(() => getClassByFlexDirectionBreak(columnSize), [columnSize])

  return { stateColSize, setColSize, columnSize, columnClasses }
}
